/**
 * Company: SPHMedia
 * Description: [Mata Mata home page banner]
 */

import BannerImageDesktop from "@assets/ugcBanner/homepage-banner-desktop.png";
import BannerImageMobile from "@assets/ugcBanner/homepage-banner-mobile.png";
import Link, { LinkRel } from "@elements/Typography/Link";
import { ReactElement } from "react";

/**
 * MataMataBannerHome
 * Description: [Mata Mata home page banner]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MataMataBannerHome(): ReactElement {
  // Add component logic and state here

  return (
    <>
      <Link
        destination="mata-mata?ref=homepage-banner"
        target="_blank"
        className="w-full mb-5 block"
        rel={LinkRel.NOOPENER}
      >
        <picture className="w-full">
          <source media="(min-width: 768px)" srcSet={BannerImageDesktop} />
          <img
            src={BannerImageMobile}
            alt="Mata Mata Banner"
            className="w-full max-w-[970px] mx-auto"
          />
        </picture>
      </Link>
    </>
  );
}
